export enum OrderedEnum {
  NEW_OLD = 'NEW_OLD',
  OLD_NEW = 'OLD_NEW',
  TOP_SALE = 'TOP_SALE',
  POPULAR = 'POPULAR',
  POPULAR_LESS = 'POPULAR_LESS',
}

export enum OrderedKeyEnum {
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
  POPULAR = 'popular',
  PURCHASED = 'purchased',
  PUBLISHED = 'publishedAt',
}
